import  axios from "axios"
import Qs from 'qs'
export function logoBanner(){
	return axios.post('/Flat/logoBanner')
}
export function Dynamic(data){
	return axios.post('/Flat/Dynamic',Qs.stringify(data))
}
export function OfflineTrainings(data){
	return axios.post('/Flat/OfflineTrainings',Qs.stringify(data))
}
export function SecurityCode(data){
	return axios.get('/Flat/SecurityCode?codeId='+data)
}
export function Signin(data){
	return axios.post('/Flat/Signin',Qs.stringify(data))
}
export function SelDocument(data){
	return axios.post('/Flat/SelDocument',Qs.stringify(data))
}
export function SelInstrumentType(){
	return axios.post('/Flat/SelInstrumentType')
}
export function SelInstrument(data){
	return axios.post('/Flat/SelInstrument',Qs.stringify(data))
}
export function SelInstrumentDetailed(data){
	return axios.post('/Flat/SelInstrumentDetailed',Qs.stringify(data))
}
export function ReservationInstrument(data){
	return axios.post('/Flat/ReservationInstrument',Qs.stringify(data))
}
export function SelInstrumentPrice(data){
	return axios.post('/Flat/SelInstrumentPrice',Qs.stringify(data))
}
export function RegOfflineTrainings(data){
	return axios.post('/Flat/RegOfflineTrainings',Qs.stringify(data))
}
export function SelExamPaper(data){
	return axios.post('/Flat/SelExamPaper',Qs.stringify(data))
}
export function GetExamPaperAndQuestions(data){
	return axios.post('/Flat/GetExamPaperAndQuestions',Qs.stringify(data))
}
export function SubmitExam(data){
	return axios.post('/Flat/SubmitExam',Qs.stringify(data))
}
export function SendValidateCode(data){
	return axios.post('/Flat/SendValidateCode',Qs.stringify(data))
}
export function SigninCode(data){
	return axios.post('/Flat/SigninCode',Qs.stringify(data))
}
export function register(data){
	return axios.post('/Flat/register',Qs.stringify(data))
}
export function SelDocumentType(data){
	return axios.post('/Flat/SelDocumentType',Qs.stringify(data))
}
export function VerificationApply(data){
	return axios.post('/Flat/VerificationApply',Qs.stringify(data))
}
export function SelUserList(data){
	return axios.post('/Flat/SelUserList',Qs.stringify(data))
}
export function applyIacuc(data){
	return axios.post('/Flat/applyIacuc',Qs.stringify(data))
}
export function ApplyExperimentModel(data){
	return axios.post('/Flat/ApplyExperimentModel',data)
}
export function SelPersonalData(data){
	return axios.post('/Flat/SelPersonalData',data)
}
export function SetPersonalData(data){
	return axios.post('/Flat/SetPersonalData',Qs.stringify(data))
}
export function SelTrainingUser(data){
	return axios.post('/Flat/SelTrainingUser',Qs.stringify(data))
}
export function SelEthicalChange(data){
	return axios.post('/Flat/SelEthicalChange',Qs.stringify(data))
}
export function AppEthicalChange(data){
	return axios.post('/Flat/AppEthicalChange',Qs.stringify(data))
}
export function UpdateIacuc(data){
	return axios.post('/Flat/UpdateIacuc',Qs.stringify(data))
}
export function TutorReview(data){
	return axios.post('/Flat/TutorReview',Qs.stringify(data))
}
export function UpdateAe(data){
	return axios.post('/Flat/UpdateAe',data)
}
export function UpdateEthicalChange(data){
	return axios.post('/Flat/UpdateEthicalChange',Qs.stringify(data))
}
export function ConsoleData(data){
	return axios.post('/Flat/ConsoleData',Qs.stringify(data))
}
export function ConsoleDataAnimal(data){
	return axios.post('/Flat/ConsoleDataAnimal',Qs.stringify(data))
}
export function ChangeIdentity(data){
	return axios.post('/Flat/ChangeIdentity',Qs.stringify(data))
}
export function Kick(data){
	return axios.post('/Flat/Kick',Qs.stringify(data))
}
export function Invite(data){
	return axios.post('/Flat/Invite',Qs.stringify(data))
}
export function TransferAccounts(data){
	return axios.post('/Flat/TransferAccounts',Qs.stringify(data))
}
export function SelConferenceLocation(data){
	return axios.post('/Flat/SelConferenceLocation',Qs.stringify(data))
}
export function SelConference(data){
	return axios.post('/Flat/SelConference',Qs.stringify(data))
}
export function SelConferenceRecordss(data){
	return axios.post('/Flat/SelConferenceRecordss',Qs.stringify(data))
}

export function AppendRecord(data){
	return axios.post('/Flat/AppendRecord',Qs.stringify(data))
}
export function addCageSq(data){
	return axios.post('/Flat/addCageSq',Qs.stringify(data))
}
export function UpdateHeadImageUrl(data){
	return axios.post('/Flat/UpdateHeadImageUrl',Qs.stringify(data))
}
export function userEndCage(data){
	return axios.post('/Flat/userEndCage',Qs.stringify(data))
}
export function EquipmentRepair(data){
	return axios.post('/Flat/EquipmentRepair',Qs.stringify(data))
}
export function SelMonthlySummary(data){
	return axios.post('/Flat/SelMonthlySummary',Qs.stringify(data))
}
export function SelConsumable(data){
	return axios.post('/Flat/SelConsumable',Qs.stringify(data))
}
export function CreateConsumableOrder(data){
	return axios.post('/Flat/CreateConsumableOrder',Qs.stringify(data))
}
export function SelSamples(data){
	return axios.post('/Flat/SelSamples',Qs.stringify(data))
}
export function placeOrderSamples(data){
	return axios.post('/Flat/placeOrderSamples',Qs.stringify(data))
}
export function Isadministrators(data){
	return axios.post('/Flat/Isadministrators',Qs.stringify(data))
}
export function CompletePay(data){
	return axios.post('/Flat/CompletePay',Qs.stringify(data))
}
export function settlementPay(data){
	return axios.post('/Flat/settlementPay',Qs.stringify(data))
}
export function ReviewSy(data){
	return axios.post('/Flat/ReviewSy',Qs.stringify(data))
}
export function DynamicId(data){
	return axios.post('/Flat/DynamicId',Qs.stringify(data))
}
export function IsResearchGroup(data){
	return axios.post('/Flat/IsResearchGroup',Qs.stringify(data))
}
export function OfflineTrainingsId(data){
	return axios.post('/Flat/OfflineTrainingsId',Qs.stringify(data))
}
export function OfflineTrainingsType(data){
	return axios.post('/Flat/OfflineTrainingsType',Qs.stringify(data))
}
export function UpdateUserPwd(data){
	return axios.post('/Flat/UpdateUserPwd',Qs.stringify(data))
}
export function UpdateUserTol(data){
	return axios.post('/Flat/UpdateUserTol',Qs.stringify(data))
}
export function UpdateTestingStatejcz(data){
	return axios.post('/Flat/UpdateTestingStatejcz',Qs.stringify(data))
}
export function SelExamPaperType(data){
	return axios.post('/Flat/SelExamPaperType',Qs.stringify(data))
}
export function SelUserPlaceOrderSamples(data){
	return axios.post('/Flat/SelUserPlaceOrderSamples',Qs.stringify(data))
}
export function SelUserPlaceOrderSamplesId(data){
	return axios.post('/Flat/SelUserPlaceOrderSamplesId',Qs.stringify(data))
}
export function SelInstrumentStrategy(data){
	return axios.post('/Flat/SelInstrumentStrategy',Qs.stringify(data))
}
export function SelIsShowTrain(data){
	return axios.post('/Flat/SelIsShowTrain',Qs.stringify(data))
}
export function RefreshPermissions(data){
	return axios.post('/Flat/RefreshPermissions',Qs.stringify(data))
}
export function SelIacuc(data){
	return axios.post('/Flat/SelIacuc',Qs.stringify(data))
}
export function SelAnimalExperiment(data){
	return axios.post('/Flat/SelAnimalExperiment',Qs.stringify(data))
}
export function SubmitExperimentApplication(data){
	return axios.post('/Flat/SubmitExperimentApplication',Qs.stringify(data))
}
export function GetUserExperimentApplicationId(data){
	return axios.post('/Flat/GetUserExperimentApplicationId',Qs.stringify(data))
}
export function UpdateExperimentApplication(data){
	return axios.post('/Flat/UpdateExperimentApplication',Qs.stringify(data))
}
export function PiExperimentApplication(data){
	return axios.post('/Flat/PiExperimentApplication',Qs.stringify(data))
}
export function SelAuditRecords(data){
	return axios.post('/Flat/SelAuditRecords',Qs.stringify(data))
}
export function GetSupplier(){
	return axios.get('/Flat/GetSupplier')
}
export function SubmitCenterEntrance(data){
	return axios.post('/Flat/SubmitCenterEntrance',Qs.stringify(data))
}
export function GetUserCenterEntranceId(data){
	return axios.post('/Flat/GetUserCenterEntranceId',Qs.stringify(data))
}
export function PiCenterEntrance(data){
	return axios.post('/Flat/PiCenterEntrance',Qs.stringify(data))
}
export function UpdateCenterEntrance(data){
	return axios.post('/Flat/UpdateCenterEntrance',Qs.stringify(data))
}
export function AllLabProvincialKeyPoints(){
	return axios.post('/Flat/AllLabProvincialKeyPoints')
}
export function SelInstrumentDateId(data){
	return axios.post('/Flat/SelInstrumentDateId',Qs.stringify(data))
}
export function InstrumentDateQRcode(data){
	return axios.get('/Flat/InstrumentDateQRcode',Qs.stringify(data))
}
export function SelBill(data){
	return axios.post('/Flat/SelBill',Qs.stringify(data))
}

export function Fileimg(data){
	return axios({
	        method: 'post',
	        url: '/Flat/Fileimg',
	        data: data,
	        headers: {
	          'Content-Type': 'multipart/form-data', // 关键
	        },
	})
}
